/**
 * contiene la información para el manejo de campos personalizados.
 */
export const defaultCampos = () => {
    return {
        id: null,
        id_empresa: null,
        campo: '',
        valor: '',
    }
}

/**
 * contiene la información para buscar las empresas.
 */
export const defaultBuscaEmpr = () => {
    return {
        name: '',
        paginador: 15,
        verPaginador: true,
        asignaciones: []
    }
}
export const defaultAsignado = () => {
    return {
        id_empresa: '',
        nombre: '',
        activo: 1,
        asignado: false,
        activo_rpq: false,
        pago: false
    }
}

/**
 * contiene la información para buscar las BASES Y AREAS.
 */
export const defaultBaseArea = () => {
    return {
        name: '',
        paginador: 10,
        verPaginador: false,
        bases_areas: [],
        bases_areas_ori: [],
        bases_areas_sinfil: []
    }
}

export const defaultUbicacion = () => {
    return {
        id_producto: "",
        id_empresa: "",
        ubicaciones_id: [],
        accion: 1
    }
}

/**
 * Carga todas las variables declaradas en el proceso.
 */
export default {
    selectedCampos: defaultCampos(),
    selectedBuscaEmpr: defaultBuscaEmpr(),
    selectedBaseArea: defaultBaseArea(),
    selectedUbicacion: defaultUbicacion(),
    asignado: defaultAsignado(),
    filtro: {
        nombre: ""
    },
    ubicaciones:[],
    camposPersonalizados:[],
    seleccionado:[],
    id_empresa: null,
    infoProducto: [],
    info:{},
    errorUbicacion:true,
    filtroUbicacion:{
      label:""
    },

    empresas: [],
    selected_empresa: {
      id: null
    },
    ubicSelecc: [],

    basearea: [],
    empresa: null,

    paginador: 10,
    verPaginador: false,

    modalAsignacion: {
      ver: false,
      cargarUbicaciones: true,
      cargarCamposPersonalizados: true
    },

    ubicacionesCantidad: [],
    loadingCancelProcess: false,
    modalSearchAndAssingProducts: {
        show: false,
        cargarUbicaciones: true,
        cargarCamposPersonalizados: true
    },
    productSelectedToAssing: {
        id:null,
    }
}
